import { createFileRoute } from '@tanstack/react-router';
import ContactEdit from '../../../features/baseData/contacts/contact/edit';
import {
  CONTACTS_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/stammdaten/kontakte/$contactId_/bearbeiten',
)({
  component: ContactEdit,
  beforeLoad: createPermissionGuard(
    getPermissionSet(CONTACTS_PERMISSIONS, 'EDIT'),
  ),
});

export const EditContactRoute = Route;
